import { render, staticRenderFns } from "./FormLabelWrapper.vue?vue&type=template&id=621cfcd3&"
import script from "./FormLabelWrapper.vue?vue&type=script&lang=ts&"
export * from "./FormLabelWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports